import React from 'react';
import {Calendar, momentLocalizer} from 'react-big-calendar';
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from 'moment';

import {
    WAITING_FOR_APPROVAL, TIMEOFF, HOLIDAY, convertTimeTo12HourFormat, 
    BLACKOUT, BIRTHDAY
} from "./Constants";

const localizer = momentLocalizer(moment);


const StaffCalendar = (props) => {

    const renderHolidays = () => {
        let holidayList = [];
        props.pto.assignedHolidayList.map(holiday => {
            let start = moment(holiday.occasion_date, "MM/DD/YYYY").toDate();
            holidayList.push({ 
                id: holiday.id, 
                title: holiday.name, 
                start: start, 
                end: start, 
                color: '#000099', 
                resource: holiday.is_restricted, 
                type: HOLIDAY, 
                allDay: 'true',
                tooltip: `${holiday.name}`, 
                all_day: true
            });
            if (holiday.alternate_date) {
                let alternateDate = moment(holiday.alternate_date, "MM/DD/YYYY").toDate();
                
                holidayList.push({ 
                    id: holiday.id * -1, 
                    title: holiday.name, 
                    start: alternateDate, 
                    end: alternateDate, 
                    color: '#000099', 
                    resource: holiday.is_restricted, 
                    type: HOLIDAY, 
                    allDay: 'true',
                    tooltip: `Alternate holiday for ${holiday.name}`, 
                    all_day: true
                });
            }
        });
        return holidayList;
    }

    const renderTimeoffDays = () => {
        return props.pto.timeoffRequestList.map(timeOff => {
            let start = moment(timeOff.start_date, "MM/DD/YYYY").add(7, 'hours');
            let end = moment(timeOff.end_date, "MM/DD/YYYY").add(7, 'hours');
            
            let color = timeOff.status === WAITING_FOR_APPROVAL ? '#009999': timeOff.color;
            return({ 
                id: timeOff.id, 

                title: `${timeOff.user_name} (${timeOff.total_time_off} ${
                    timeOff.is_pto_in_hour ? 'hour' : 'day'}${
                        timeOff.total_time_off > 1 ? 's' : ''})`, 

                tooltip: `${timeOff.time_off_name} (${timeOff.total_time_off} ${
                        timeOff.is_pto_in_hour ? 'hour' : 'day'
                    }${timeOff.total_time_off > 1 ? 's' : ''}) [${
                        start.format("MM/DD/YYYY")} ${timeOff.is_full_first_day ? '' 
                        : convertTimeTo12HourFormat(timeOff.start_time, "09:00")
                    } to ${end.format("MM/DD/YYYY")} ${timeOff.is_full_last_day ? '' 
                        : convertTimeTo12HourFormat(timeOff.end_time, "17:00")}]`,

                start: start, 
                end: end, 
                color: color, 
                resource: timeOff.is_restricted, 
                type: TIMEOFF,
                satus: timeOff.status,
                pto_type: timeOff.pto_type,
                description: timeOff.description,
                comment: timeOff.comment,
                all_day: true,
                start_time: timeOff.start_time,
                end_time: timeOff.end_time,
                is_full_first_day: timeOff.is_full_first_day,
                is_full_last_day: timeOff.is_full_last_day,
                is_paid: timeOff.is_paid,
                user: timeOff.user
            });
        });
    }

    const handleDoubleClick = (obj, e) => {
        if (obj.type === TIMEOFF && obj.user === props.selectedUser) {
            props.showTimeOffRequest(obj, false);
        } else {
            props.showTimeOffRequest({}, true);
        }
    }

    let holidayList = renderHolidays();
    const minTime = new Date();
    minTime.setHours(9, 0,0);
    const maxTime = new Date();
    maxTime.setHours(18, 0, 0);

    let timeOffDayList = renderTimeoffDays();

    const blackoutDayList = props.pto.blackoutDayList.map(blackoutDay => {
        let start = moment(blackoutDay.date, "MM/DD/YYYY").toDate();
        return { 
            id: blackoutDay.id, 
            title: blackoutDay.reason, 
            start: start, 
            end: start, 
            color: '#333', 
            resource: true, 
            type: BLACKOUT, 
            allDay: 'true',
            tooltip: `${blackoutDay.reason}`
        };
    });

    const birthDayList = props.pto.birthDayList.map(user => {
        let start = moment(user.birthday, "MM/DD/YYYY").toDate();
        return { 
            id: user.id, 
            title: <span><i className="fa fa-birthday-cake" style={{color: "#ff80aa"}}/>
                {' '}{user.full_name}
            </span>, 
            start: start, 
            end: start, 
            color: '#85553A', 
            resource: true, 
            type: BIRTHDAY, 
            allDay: 'true',
            tooltip: `${user.full_name}'s Birthday`
        };
    });

    holidayList = [
        ...holidayList, 
        ...timeOffDayList, 
        ...blackoutDayList,
        ...birthDayList
    ];

    return (
        <Calendar
            localizer={localizer}
            events={holidayList}
            startAccessor="start"
            endAccessor="end"
            showMultiDayTimes
            defaultDate={moment().toDate()}
            eventPropGetter={event => {
                const backgroundColor = event && event.color;
                return {style: {backgroundColor, padding: '0 4px'} };
            }}
            min={minTime}
            max={maxTime}
            style={{height: '100%', minHeight: props.height}}
            views={['month']}
            onDoubleClickEvent={(event, e) => handleDoubleClick(event, e)}
            allDayAccessor={"all_day"}
            tooltipAccessor="tooltip"
        />
    )
}

export default StaffCalendar;



// WEBPACK FOOTER //
// ./src/components/pto/StaffCalendar.js